import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ExamReadyRank')
export default class ExamReadyRank {
  constructor() {
    this.rankCode = '';
    this.title = '';
    this.periodStart = '';
    this.periodEnd = '';
    this.numberOfQuestions = 0;
    this.timeLimit = 0;
  }

  @JsonProperty('exam_rank_code')
  public rankCode: string;

  @JsonProperty('exam_rank_title')
  public title: string;

  @JsonProperty('examination_period_start')
  public periodStart: string;

  @JsonProperty('examination_period_end')
  public periodEnd: string;

  @JsonProperty('number_of_questions')
  public numberOfQuestions: number;

  @JsonProperty('time_limit')
  public timeLimit: number;
}
